import { useState } from 'react';

import './CommunityGroupList.scss';
import { getString } from '../../../helpers/styles';
import Transition from '../../Transition/Transition';
import icons from '../../../shared/assets/icons/redesign';
import { isCommunityGroupMember } from '../../../helpers/user';
import CommunityFilterGroupPopupContent from '../../redesign/PopupContent/CommunityFilterGroupPopupContent/CommunityFilterGroupPopupContent.jsx';

const { Filter } = icons;

const months = [
  'januari',
  'februari',
  'maart',
  'april',
  'mei',
  'juni',
  'juli',
  'augustus',
  'september',
  'oktober',
  'november',
  'december'
];

export default function CommunityGroupList({
  user,
  sliderList,
  userJoinGroup,
  list = []
}) {
  const [filterPopup, showFilterPopup] = useState(false);

  const allGroupTypes = sliderList.concat(list).reduce((groupTypes, item) => {
    item.userGroupTypes.forEach((item) => groupTypes.add(item.groupType.name));

    return groupTypes;
  }, new Set());

  const [filteredGroupTypes, setFilteredGroupTypes] = useState('Onderwerp');

  let displayedList = list.filter((item) =>
    item.userGroupTypes.find(
      (item) => filteredGroupTypes === item.groupType.name
    )
  );

  if (filteredGroupTypes === 'Maand groep')
    displayedList = getMonthGroupList(displayedList);

  const displayedSliderList = sliderList.filter((item) =>
    item.userGroupTypes.find(
      (item) => filteredGroupTypes === item.groupType.name
    )
  );

  return (
    <div className="componentWrap">
      <div className="communityGroupList">
        <div className="communityGroupList-header">
          <h2 className="communityGroupList-header-title">Ontdek groepen</h2>

          <div>
            <Filter
              onClick={() => showFilterPopup(true)}
              className="cursor-pointer"
            />
          </div>
        </div>

        <ul className="communityGroupList-slider">
          {displayedSliderList.map((group) => {
            const memberCount = group.members.length;

            return (
              <li key={group.xuid} className="communityGroupList-slider-item">
                <img
                  className="communityGroupList-slider-item-img"
                  src={group.imageUrl}
                  alt="group-image"
                />

                <h5 className="communityGroupList-slider-item-name">
                  {group.displayName}
                </h5>

                <span className="communityGroupList-slider-item-details">
                  {memberCount === 0
                    ? 'Word de eerste deelnemer!'
                    : memberCount === 1
                    ? '1 deelnemer in deze groep'
                    : `${memberCount} deelnemers in deze groep`}
                </span>

                <Button
                  user={user}
                  group={group}
                  userJoinGroup={userJoinGroup}
                  className="communityGroupList-slider-item-btn"
                />
              </li>
            );
          })}
        </ul>

        <ul className="communityGroupList-list">
          {displayedList.map((group) => {
            const lastPostDate =
              !!group.topics.length &&
              new Date(
                Math.max.apply(
                  null,
                  group.topics.map(({ createdAt }) => new Date(createdAt))
                )
              );

            return (
              <li key={group.xuid} className="communityGroupList-list-item">
                <img
                  className="communityGroupList-list-item-img"
                  src={group.imageUrl}
                  alt="group-image"
                />

                <div>
                  <h5 className="communityGroupList-list-item-name">
                    {group.displayName}
                  </h5>

                  <span className="communityGroupList-list-item-member-count">
                    {group.members.length}{' '}
                    {group.members.length === 1 ? 'lid' : 'leden'}
                  </span>

                  <span className="communityGroupList-list-item-activity-date">
                    {lastPostDate && (
                      <>
                        Last post:{' '}
                        {lastPostDate.toLocaleDateString('nl', {
                          day: 'numeric',
                          year: 'numeric',
                          month: 'short'
                        })}
                      </>
                    )}
                  </span>
                </div>

                <Button
                  user={user}
                  group={group}
                  userJoinGroup={userJoinGroup}
                  className="communityGroupList-list-item-btn"
                />
              </li>
            );
          })}
        </ul>
      </div>

      <Transition on={filterPopup}>
        <div className="communityTopicList-filter-popup">
          <CommunityFilterGroupPopupContent
            allGroupTypes={allGroupTypes}
            filteredGroupTypes={filteredGroupTypes}
            onClose={() => showFilterPopup(false)}
            setFilteredGroupTypes={setFilteredGroupTypes}
          />
        </div>
      </Transition>
    </div>
  );
}

function Button({ user, userJoinGroup, group, className }) {
  const isMember = isCommunityGroupMember(group, user);

  return (
    <button
      onClick={() =>
        isMember
          ? (location.href = `/community/${group.uri}`)
          : userJoinGroup({
              variables: {
                userGroupXuid: group.xuid
              }
            }).then(() => (location.href = `/community/${group.uri}`))
      }
      className={getString([
        {
          value: `${className} cursor-pointer`,
          condition: true
        },
        {
          value: 'communityGroupList-btn-secondary',
          condition: isMember
        }
      ])}
    >
      {isMember ? 'Bekijken' : 'Deelnemen'}
    </button>
  );
}

function getMonthGroupList(list) {
  const targetList = list.sort((a, b) => {
    return getDate(a.uri) < new getDate(b.uri) ? -1 : 1;
  });

  const currentGroupIndex = targetList.findIndex(
    (item) =>
      new Date().getMonth() === getDate(item.uri).getMonth() &&
      new Date().getFullYear() === getDate(item.uri).getFullYear()
  );

  return currentGroupIndex ? targetList.slice(currentGroupIndex) : targetList;

  function getDate(uri) {
    const [month, year] = uri.split('-');

    const monthIndex = months.findIndex((item) => item === month.toLowerCase());

    return new Date(year, monthIndex, 1);
  }
}
